import { easingSmootherstep, interpolate } from 'culori/fn';
import type { Hsv } from 'culori/fn';

export const transitionBetweenColors = (
  fromHsv: Hsv,
  toHsv: Hsv,
  onColorStep: (hsv: Hsv) => void,
  onTransitionEnd?: () => void,
) => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    onColorStep(toHsv);
    onTransitionEnd?.();
    return;
  }

  const interpolator = interpolate(
    [
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      easingSmootherstep(0.33),
      fromHsv,
      toHsv,
    ],
    'hsv',
  );
  const steps = 5;

  // every 16ms (for 60fps), update the color value
  const intervalMs = 16;

  let count = 0;
  let lastTime = performance.now();

  const step = (now: number) => {
    if (count >= steps) {
      // Ensure we set the final color
      onColorStep(toHsv);
      onTransitionEnd?.();
      return;
    }

    if (now - lastTime >= intervalMs) {
      const animationProgress = count / steps; // 0 to 1, where 0 = start, 1 = end
      const interpolatedHsv = interpolator(animationProgress);

      onColorStep(interpolatedHsv);

      // eslint-disable-next-line no-plusplus
      count++;
      lastTime = now;
    }

    requestAnimationFrame(step);
  };

  requestAnimationFrame(step);
};
